import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared/shared.module';
import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { DepartmentsComponent } from './components/departments/departments.component';
import { HeaderComponent } from './header.component';
import { IndicatorComponent } from './components/indicator/indicator.component';
import { LinksComponent } from './components/links/links.component';
import { MegamenuComponent } from './components/megamenu/megamenu.component';
import { MenuComponent } from './components/menu/menu.component';
import { NavComponent } from './components/nav/nav.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
    declarations: [
        AccountMenuComponent,
        DepartmentsComponent,
        HeaderComponent,
        IndicatorComponent,
        LinksComponent,
        MegamenuComponent,
        MenuComponent,
        NavComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatTooltipModule,
        SharedModule
    ],
    exports: [
        HeaderComponent,
        IndicatorComponent,
        AccountMenuComponent
    ]
})
export class HeaderModule { }
